const SEARCH_TASK_LABEL = "search transactional deals";

/**
 * Returns whether a job task represents the Search Transactional Deals step.
 * @param {Object} task
 * @returns {boolean}
 */
export function isSearchTransactionalDealsTask(task) {
  return String(task?.taskDetails ?? "")
    .toLowerCase()
    .includes(SEARCH_TASK_LABEL);
}

/**
 * Computes deal-search progress for the Job View modal header.
 * @param {Object|null|undefined} selectedJob
 * @param {Array} [jobTasks]
 * @returns {{ visible: false } | { visible: true, percent: number, progressCount: number, targetCount: number, isComplete: boolean }}
 */
export function getJobViewDealSearchProgress(selectedJob, jobTasks = []) {
  const targetCount = Number(selectedJob?.targetCount) || 0;
  const progressCount = Number(selectedJob?.progressCount) || 0;

  if (targetCount <= 0) {
    return { visible: false };
  }

  const hasSearchTask = jobTasks.some(isSearchTransactionalDealsTask);
  const isApplicable =
    hasSearchTask ||
    progressCount > 0 ||
    selectedJob?.jobStatus === "COMPLETE";

  if (!isApplicable) {
    return { visible: false };
  }

  const percent = Math.min(100, Math.round((progressCount / targetCount) * 100));
  const isComplete =
    percent >= 100 || selectedJob?.jobStatus === "COMPLETE";

  return {
    visible: true,
    percent,
    progressCount,
    targetCount,
    isComplete,
  };
}
